import Config from './config'
import axios from 'axios'
import { $http, $request } from './http'
import Wx from 'wechat-js-sdk'
import COVERAPP from './COVERAPP'
import Store from '@/store'

export default {
    // 判断是不是超链接
    isHyperlinks (url: string) {
        return /^http(s)?:\/\/(.*)?/.test(url)
    },
    // 判断是否为空
    isEmpty (obj: any): boolean {
        if (obj == '' || obj == null || obj == undefined) {
            return true
        }
        return false
    },

    // 获取url参数值
    getUrl (name: string): string {
        let fullPath = window.location.href
        if (fullPath.indexOf('?') > -1) {
            let searchData = fullPath.split('?')[1].split('&')
            let searchParams = {}
            searchData.forEach((val, i) => {
                let valData = val.split('=')
                searchParams[valData[0]] = valData[1]
            })
            return searchParams[name]
        } else {
            return ''
        }
    },
    // 分享
    onshare (data: any) {
        let shareData = JSON.parse(JSON.stringify(data))
        shareData.callback = (ret: any) => {
            const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret 
            const origin = data.origin || ''
            if (origin != 'None' && !this.isEmpty(origin)) {
                this.track('share', '分享链接到' + origin)
            } else {
                this.track('share', '分享')
            }
        }
        // 微信分享
        if (COVERAPP.Attribute.isApp()) {
            COVERAPP.Method.onshare(shareData)
        } else if (COVERAPP.Attribute.isWeixin()) {
            this.setWeChatConf().then(() => {
                this.wxOnshare(shareData)
            })
        // qq分享
        } else if (COVERAPP.Attribute.isQQ()) {
            if (window.mqq && window.mqq.data && window.mqq.data.setShareInfo) {
                this.qqShare(shareData)
            } else {
                this.loadjs('https://open.mobile.qq.com/sdk/qqapi.js?_bid=152').then(() => {
                    this.qqShare(shareData)
                })
            }
        }
    },
    // qq分享
    qqShare (shareData: any) {
        window.mqq.data.setShareInfo({
            title: shareData.title,
            share_url: shareData.link,
            image_url: shareData.imgUrl,
            desc: shareData.desc
        })
    },
    // 微信配置
    setWeChatConf () {
        return new Promise((resolve) => {
            $http(`/weixin/getConf/`, {
                url: encodeURIComponent(window.location.href.split('#')[0])
            }).then((data: any) => {
                const D = data
                Wx.config({
                    debug: false,
                    appId: D.appId,
                    timestamp: D.timestamp,
                    nonceStr: D.nonceStr,
                    signature: D.signature,
                    jsApiList: [
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'previewImage'
                    ]
                })
                resolve('')
            })
        })
    },
    // 微信分享
    wxOnshare (obj: any) {
        Wx.ready(() => {
            // 分享到朋友圈
            Wx.onMenuShareTimeline(obj)
            // 分享给朋友
            Wx.onMenuShareAppMessage(obj)
            // 分享到QQ
            Wx.onMenuShareQQ(obj)
            // 分享到腾讯微博
            Wx.onMenuShareWeibo(obj)
            // 分享到QQ空间
            Wx.onMenuShareQZone(obj)
        })
    },
    wxPreviewImage (current: string, urls: string[]) {
        Wx.previewImage({
            current, // 当前显示图片的http链接
            urls // 需要预览的图片http链接列表
        });
    },
    // 动态加载js
    loadjs (src: string) {
        return new Promise((resolve) => {
            const scriptNode: any = document.createElement('script')
            scriptNode.setAttribute('type', 'text/javascript')
            scriptNode.setAttribute('src', src)
            document.body.appendChild(scriptNode)
            // IE 判断
            if (scriptNode.readyState) {
                scriptNode.onreadystatechange = () => {
                    if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
                        resolve('')
                    }
                }
            } else {
                scriptNode.onload = () => {
                    resolve('')
                }
            }
        })
    },
    // 获取用户信息
    getUser (cb: (res: any) => void): void {
		const userinfo = sessionStorage.getItem('COVER_USERINFO');
        if (userinfo) {
          cb(JSON.parse(userinfo));
          return;
        }
        const _this = this
        if (COVERAPP.Attribute.isApp()) {
            let isLoad_Bridging = setInterval(() => {
                try {
                    COVERAPP.Method.GetUser({
                        callback(res: any) {
                            clearInterval(isLoad_Bridging)
                            let userinfo = JSON.parse(res)
                            if (!_this.isEmpty(userinfo.token)) {
                                userinfo.origin = 'app'
                                if (COVERAPP.Attribute.isIOS()) {
                                    if (COVERAPP.Attribute.appVersion() >= 450) {
                                        userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)))
                                    }
                                }
                                if (_this.isEmpty(userinfo.avatar)) {
                                    userinfo.avatar = _this.defaultUser()
                                }
                                $http('/wap/getLoginUserInfo', {
                                    token: userinfo.token
                                }, 'get').then((data: any) => {
                                    userinfo.avatar = data.avatar
                                    userinfo.nickname = data.nickname
                                    if (_this.isEmpty(userinfo.avatar)) {
                                        userinfo.avatar = _this.defaultUser()
                                    }
                                    sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo))
                                    cb(userinfo)
                                }).catch(() => {
                                    sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo))
                                    cb(userinfo)
                                })
                            } else {
                                cb('')
                            }
                        }
                    });
                } catch (e) { }
            }, 100)
            return
        }
        if (COVERAPP.Attribute.isWeixin()) {
            let code = this.getUrl('code');
            let codestate = this.getUrl('state');
            // 如果没有拿到code，则去授权登录
            if (this.isEmpty(code) || codestate.indexOf('COVER') < 0) {
                window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Config.wx_appid + '&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_userinfo&state=COVER#wechat_redirect';
                return
            }
            $request('/user/weixin', {
                code
            }).then((data: any) => {
                let userinfo = data
                userinfo.origin = 'wx'
                userinfo.token = userinfo.openid
                sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo))
                if (location.href.indexOf('#/')) {
                    window.location.href = window.location.origin + window.location.pathname + '#/' + (window.location.href.split('#/')[1] || '')
                }
                cb(userinfo)
            }).catch(() => {
                cb({
                    origin: 'none'
                })
            })
            return
        }
        cb('')
    },
    // 在评论内容中渲染自定义表情
    renderReplyContent(str: string): string {
        let cdn_url_base = 'https://wapcdn.thecover.cn/wap/1.6.0/img/';
        let key_arr = [{
            '困': cdn_url_base + 'emotion_kun.png'
        }, {
            '笑cry': cdn_url_base + 'emotion_xiaocry.png'
        }, {
            '卖萌': cdn_url_base + 'emotion_maimeng.png'
        }, {
            '发怒': cdn_url_base + 'emotion_fanu.png'
        }, {
            '可怜': cdn_url_base + 'emotion_kelian.png'
        }, {
            '呕吐': cdn_url_base + 'emotion_outu.png'
        }, {
            '坏笑': cdn_url_base + 'emotion_huaixiao.png'
        }, {
            '大笑': cdn_url_base + 'emotion_daxiao.png'
        }, {
            '害羞': cdn_url_base + 'emotion_haixiu.png'
        }, {
            '尴尬': cdn_url_base + 'emotion_ganga.png'
        }, {
            '得意': cdn_url_base + 'emotion_deyi.png'
        }, {
            '微笑': cdn_url_base + 'emotion_weixiao.png'
        }, {
            '流汗': cdn_url_base + 'emotion_liuhan.png'
        }, {
            '流泪': cdn_url_base + 'emotion_liulei.png'
        }, {
            '爱心': cdn_url_base + 'emotion_aixin.png'
        }, {
            '生气': cdn_url_base + 'emotion_shengqi.png'
        }, {
            '白眼': cdn_url_base + 'emotion_baiyan.png'
        }, {
            '耍酷': cdn_url_base + 'emotion_shuaku.png'
        }, {
            '花痴': cdn_url_base + 'emotion_huachi.png'
        }, {
            '鼻血': cdn_url_base + 'emotion_bixue.png'
        }];
        for (let i = 0; i < key_arr.length; i++) {
            str = str.replace((new RegExp('\\[' + Object.keys(key_arr[i])[0] + '\\]', 'gi')), ('<img src="' + key_arr[i][Object.keys(key_arr[i])[0]] + '" class="custom-emoji-in-replys">'));
        }
        return str;
    },
    // 埋点
    track (type = 'load', label?: number | string) {
        const userinfo = sessionStorage.getItem('COVER_USERINFO') || ''
        const deviceId = this.getDeviceId()
        const aid = Store.state.aid
        axios.post(Config.TRACK_URL, {
            applicationId: 'thecover', // 必填， 固定值， 后面确定
            eventType: type, // 必填， 枚举。 有load(页面加载), share(分享),click(按钮点击)
            eventTime: new Date().getTime(), // 必填， 时间戳
            activeId: aid, // 必填， 固定值， easy那边最终确定
            distinctId: deviceId, // 必填， 用来关联用户的基本信息，可以游客随机，但是尽量保证一次打开使用同一个而不变，有设备的用设备id， 登录之后用userid。
            uri: window.location.href, // 必填， 页面的URI
            deviceId: deviceId, // 选填.  用来关联APP的设备。
            eventParam: {
                label,
                userinfo,
            } // 具体的参数的值
        })

        if (type === 'share') {
            let url = Config.ACTIVITY_URL + '/activity/share?aid=' + aid + 'did' + deviceId;
            this.onloadImg(url)
        }

    },
    // 获取设备id
    getDeviceId (): string {
        const ua = navigator.userAgent
        if (/TheCover/i.test(ua)) {
            return 'app-' + ua.split('(TheCover_')[1].split('_')[2].split(')')[0];
        }
        let did = localStorage.getItem('COVER_APM_DID')
        if (!did) {
            did = 'other-' + this.uuid();
            localStorage.setItem('COVER_APM_DID', did)
        }
        return did
    },
    // 吊起app
    downloadApp (id?: number | string, flag: number = 14): void {
        this.track('download', id)
        if (COVERAPP.Attribute.isAndroid()) {
            const downHref = id ? `${Config.APP_SCHEME_URL}/news?id=${id}&flag=${flag}&version=${new Date().getTime()}` : `${Config.APP_SCHEME_URL}/open`
            window.location.href = `${Config.WEXIN_APP_DOWNLOAD_ADDRESS}&android_schema=${encodeURIComponent(downHref)}`
        } else {
            window.location.href = id ? `${Config.UNIVERSALLINK}?version=${new Date().getTime()}&to=news&id=${id}&flag=${flag}` : `${Config.UNIVERSALLINK}?version=${new Date().getTime()}`
        }
    },
    // 加载图片
    onloadImg (url: string) {
        return new Promise((resolve) => {
            const img = new Image()
            img.crossOrigin = 'Anonymous' 
            img.src = url
            img.addEventListener('load', () => {
                resolve(img)
            })
            img.addEventListener('error', () => {
                resolve('error')
            })
        })
    },
    // 设置根字体大小
    rootRem (size?: number) {
        if (!size || document.documentElement.clientWidth / document.documentElement.clientHeight <= size) {
            document.documentElement.style.fontSize =  `${document.documentElement.clientWidth / 10}px`
        } else {
            var thisWidth = document.documentElement.clientHeight * size
            document.documentElement.style.fontSize = `${thisWidth / 10}px`
        } 
        let html = document.getElementsByTagName('html')[0]
        let winFontS = parseFloat(window.getComputedStyle(html).fontSize)
        let htmlFontS = parseFloat(html.style.fontSize)
        let setFontS = htmlFontS
        if (winFontS != htmlFontS) {
            let whileCount = 0
            while (true) {
                winFontS = parseFloat(window.getComputedStyle(html).fontSize)
                let delta = winFontS - htmlFontS
                if (Math.abs(delta) >= 0.1) {
                    if (delta > 0) setFontS = setFontS - 0.1
                    else setFontS = setFontS + 0.1
                    html.setAttribute('style', `font-size:${setFontS}px!important`)
                } else {
                    break
                }
                if (whileCount++ > 200) {
                    break
                }
            }
        }
    },
    // 页面加载loading
    pageLoading () {
        const loadDom = document.getElementById('loading_wrap') as HTMLDivElement
        const errorDom = document.getElementById('load_error') as HTMLDivElement
        errorDom.style.display = 'none'
        loadDom.style.display = 'block'
        if (!window.timeoutIds) {
            window.timeoutIds = setTimeout(() => {
                if (!!(window.attachEvent && !window.opera)) { 
                    document.execCommand('stop')
                } else { 
                    window.stop()
                }
                errorDom.style.display = 'block'
                loadDom.style.display = 'none'
            }, 30000)
        }
    },
    // 页面加载完成
    pageLoaded () {
        const loadDom = document.getElementById('loading_wrap') as HTMLDivElement
        loadDom.style.display = 'none'
        clearTimeout(window.timeoutIds)
        window.timeoutIds = null
    },
    // toast提示
    toast (text: string) {
        const toastDom = document.createElement('div')
        toastDom.className = 'toast'
        toastDom.innerHTML = `<div class="toast-inner">${text}</div>`
        document.body.appendChild(toastDom)
        setTimeout(() => {
            toastDom.className = `${toastDom.className} leave`
            toastDom.addEventListener('animationend', () => {
                document.body.removeChild(toastDom)
            })
            toastDom.addEventListener('webkitAnimationend', () => {
                document.body.removeChild(toastDom)
            })
        }, 5000)
    },
    // 用户默认头像
    defaultUser (img?: string) {
        return img || 'https://wapcdn.thecover.cn/wap/4.2.1/images/user_default.png'
    },
    // 人机验证
    captcha (data: any) {
        return new Promise((resolve, reject) => {
            const captcha = new window.TencentCaptcha(`${data.appid}`, (ret: any) =>{
                if (!ret.ticket) {
                    reject()
                    return
                }
                $request('/captcha/user', {
                    type: data.type,
                    ticket: ret.ticket,
                    randstr: ret.randstr,
                    userinfo: Store.state.userInfo
                }, 'post').then(() => {
                    resolve('')
                }).catch(() => {
                    reject()
                })
            })
            captcha.show()
        })       
    },
    // 生成UUID
    uuid() {
      const id = [
        new Date().getTime().toString(16).substring(3, 11).toLocaleUpperCase(),
        Math.random().toString(16).substring(2, 6).toLocaleUpperCase(),
        Math.random().toString(16).substring(2, 6).toLocaleUpperCase(),
        Math.random().toString(16).substring(2, 6).toLocaleUpperCase(),
        Math.random().toString(16).substring(2, 14).toLocaleUpperCase(),
      ];
    
      return id.join('-');
    },
    // 向剪切板写入输入
    copyToClipborad(text: string) {
      let newInput = document.createElement("input");
      newInput.value = text;
      document.body.appendChild(newInput);
      newInput.select();
      document.execCommand("Copy");
      newInput.remove();
    },
    // 调用用户跟踪接口
    userTrack(aid: string) {
      const { devicePixelRatio, innerWidth, innerHeight } = window;
      $request('/user/track', {
        aid,
        screenWidth: devicePixelRatio * innerWidth,
        screenHeight: devicePixelRatio * innerHeight,
      }, 'post');
    },
}
